import "bootstrap/dist/css/bootstrap.min.css";

const NotFoundPage = () => {
    return (
    <div className="d-flex align-items-center justify-content-center vh-100">
        <div className="text-center text-white">
            <h1 className="display-1 fw-bold">404</h1>
            <p className="fs-3"> <span className="text-danger">Oops!</span> Page not found.</p>
            <p className="lead">
                The page you are looking for does not exist.
              </p>
            <a href="/" className="btn btn-primary">Go Home</a>
        </div>
    </div>
    )
}

export default NotFoundPage;